/**
 * FAQ toggle functionality
 * 
 *    Open and close Answer
 *    with a mouse click.
 * 
 */

(function(){
  var faq_element = document.querySelector('.block-faq');
  if (!faq_element) {
    return;
  }
  var rows = faq_element.getElementsByClassName('faq-item');

  function createFaqToggleHandler(target) {
    return function() {
      if (target.classList.contains('active')) {
        target.classList.remove('active');
      } else {
        target.classList.add('active');
      }
    };
  }

  for (var i = 0; i < rows.length; i++) {
    var faq_element = rows[i];
    faq_element.addEventListener('click', createFaqToggleHandler(faq_element));
  }
}());
